<template>
    <div class="block13">
          <!-- 返回 -->
          <div class="return">
              <router-link to="/"><span class="arrow"></span>返回首页</router-link>
          </div>
          <!-- 返回 -->
          <!-- 内容 -->
          <div class="container">
            <h2 class="title1">换挡</h2>

            <div class="container-content">
              <p>您的摩托车变档杆有5个档位，一个档位向下，四个档位朝上。</p>
               <img src="./img/huandang.png" alt="" width="100%">
            </div>
           
           
           
            <div class="foot-btn">
              <div class="prev">
                <router-link to="/block12a">上一页</router-link>
              </div>
              <div class="next">
                <router-link to="/block14">下一页</router-link>
              </div>
          </div>
          </div>
         
        </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>